import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Logout = () => {
	const { logout } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		logout();
		navigate('/');
	}, [logout, navigate]);

	return <div className="p-6">Signing out...</div>;
};

export default Logout;


